export const primitive = {};
